import { useGLTF, Outlines, Edges } from '@react-three/drei';
import { useMemo, useState } from 'react';

const HexagonBoard = () => {
  const gltf = useGLTF('/models/tiles/base/hex_grass.gltf');

  // Extract geometry and materials from the first mesh
  const [geometry, materials] = useMemo(() => {
    let geometry;
    let materials;
    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        geometry = child.geometry;
        materials = child.material;
        child.receiveShadow = true;
      }
    });
    return [geometry, materials];
  }, [gltf]);

  // Generate hexagon grid positions
  const hexPositions = useMemo(() => {
    const positions = [];
    const radius = 3; // Number of rings around center
    const size = 1.15; // Size/spacing of hexagons (may need adjustment based on model size)

    // Offset constants for hex grid
    const xOffset = size * Math.sqrt(3);
    const zOffset = size * 1.5;

    for (let q = -radius; q <= radius; q++) {
      const r1 = Math.max(-radius, -q - radius);
      const r2 = Math.min(radius, -q + radius);

      for (let r = r1; r <= r2; r++) {
        const x = xOffset * (q + r / 2);
        const z = zOffset * r;
        positions.push([x, 0, z]);
      }
    }

    return positions;
  }, []);

  const [hoveredTile, setHoveredTile] = useState<number | null>(null);

  return (
    <>
      {hexPositions.map((position, index) => (
        <mesh
          key={index}
          geometry={geometry}
          material={materials}
          position={position}
          scale={[1, 1, 1]}
          receiveShadow
          onPointerOver={(e) => {
            e.stopPropagation();
            setHoveredTile(index);
          }}
          onPointerOut={(e) => {
            e.stopPropagation();
            setHoveredTile(null);
          }}
        >
          {hoveredTile === index && <Edges linewidth={15} scale={1} color="white" />}
        </mesh>
      ))}
    </>
  );
};

export default HexagonBoard;
